enum FaceFilterMode {
  And = 'And',
  Or = 'Or'
}
export default FaceFilterMode
